<template>
  <div
      class="collapse flightList__faresTable surface"
      v-if="showFamilyFareRules && familyFareRules"
  >
    <div class="flightList__faresTableContainer">
      <div
          class="flightList__faresTableRow"
          v-for="(condition, index) in conditions"
          :key="'row' + index"
      >
        <div class="flightList__faresTableHead">
          <i class="fas" :class="'fa-' + condition.icon"></i>
          <span>{{ $t(`shopping_lib.${condition.service}_service`) }}</span>
        </div>
        <div class="flightList__faresTableGroup">
          <span
              class="flightList__faresTableCell"
              v-for="(fare, i) in classes"
              :key="i"
          >
            {{ normalizedName(`${condition.service}_${fare}`)}}
          </span>
        </div>
      </div>
      <div class="flightList__faresTableRow  --policies" v-if="familyFareRules.showPolicies">
        <div class="flightList__faresTableHead"></div>
        <div class="flightList__faresTableGroup">
          <span
              class="flightList__faresTableCell"
              v-for="(fare, i) in classes"
              :key="i"
          >
            <span v-html="normalizedName(`policy_${fare}`)"></span>
          </span>
        </div>
      </div>
      <div class="flightList__faresTableRow" v-if="familyFareRules.showNotice">
        <div class="flightList__faresTableHead"></div>
        <div
            class="flightList__faresTableGroup"
        >
          <span class="flightList__faresTableCell">
            <span v-html="normalizedName('common_policies')"></span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { orderBy } from 'lodash'

export default {
  name: 'FareConditions',
  props: {
    familyFareRules: {
      required: true
    },
    familyFares: {
      required: true
    },
    showFamilyFareRules: {
      required: false,
      default: true
    }
  },
  methods: {
    normalizedName: function (label) {
      const normalizedLabel = `shopping_lib.${label}`.toLowerCase()
      return this.$t(normalizedLabel)
    }
  },
  computed: {
    classes: function () {
      return this.familyFares.classes.map(x => x.split('_')[0])
    },
    conditions: function () {
      return orderBy(this.familyFareRules.conditions, ['order'])
    }
  }
}
</script>

<style scoped>

</style>
